import { scopedCards } from '../core/load.js';
import { state } from '../core/state.js';
import { esc } from '../core/text.js';
import { renderCurrency, saveProgress } from '../progress/xp.js';
import { startSession } from '../study/learn.js';
import { confetti } from '../ui/confetti.js';
import { SFX, pushPop, toast } from '../ui/toast.js';
import { cardManagerModal } from '../views/dashboard.js';
import { ADV_PETS, ADV_WORLDS, GAME, PET_CHEST_COST, PET_DUPE_REFUND, PET_MAX, PET_RARITY, gPetLevel, gWorld, petBonusText } from './data.js';
import { gBuyUpgrade, gClaimQuest, gClaimWeekly, gDailyChest, gEquip, gearPanelHTML, questCardHTML, renderGearPanel } from './equip.js';
import { G, gEnchantItem, gStats, gXpToNext } from './items.js';
import { advDuelModal, advLeaderboardModal, advOpenChest, advStartTick, kompendiumModal } from './screens.js';
import { SKILL_BY_ID, SKILL_TREE, gEnsureObstacle, gFokusSpecial, gSectionMeta, gSkillCanUnlock, gSkillNodeClick, gSkillPoints, gSkillUnlocked, gUpgradeCost, sectionWorld, worldLen, worldStart } from './world.js';

/* ── Anzeige ── */
export const RPG = (f) => 'assets/rpg/' + f;
/* Mini-Karte der aktuellen Welt: Räume bis zum Boss. */
export function advRoomMapHTML() {
  const si = sectionWorld(G().section); const rest = Math.max(0, si.len - si.idx);
  const lbl = `<span class="room-lbl">📍 Raum <b>${si.idx}</b>/${si.len}${si.isExam ? ' · <b>Boss!</b>' : ' · noch ' + rest + ' bis 👑'}</span>`;
  if (si.len > 14) {   // sehr lange Welt: schlanke Leiste statt vieler Punkte
    return `<div class="adv-rooms bar" title="Räume dieser Welt">${lbl}<span class="room-bar"><i style="width:${Math.round(si.idx / si.len * 100)}%"></i></span></div>`;
  }
  const dots = Array.from({ length: si.len }, (_, i) => {
    const r = i + 1, boss = r === si.len, done = r < si.idx, cur = r === si.idx;
    return `<span class="room-dot ${boss ? 'boss' : ''} ${done ? 'done' : ''} ${cur ? 'cur' : ''}" title="Raum ${r}${boss ? ' · Boss' : ''}">${boss ? '👑' : cur ? '📍' : ''}</span>`;
  }).join('');
  return `<div class="adv-rooms" title="Räume dieser Welt bis zum Boss">${lbl}<span class="room-dots">${dots}</span></div>`;
}
export function advUpdateNav() {
  const on = G().on;
  document.querySelectorAll('[data-view="adventure"]').forEach((el) => { el.style.display = on ? '' : 'none'; });
}
export function renderAdventure() {
  const box = document.getElementById('view-adventure'); if (!box) return;
  const g = G();
  if (!g.on) { box.innerHTML = '<div class="card-panel"><p class="page-sub">Das Wissensabenteuer ist ausgeschaltet. Du kannst es in den Einstellungen aktivieren.</p></div>'; return; }
  gEnsureObstacle();
  const gotFreeChest = gDailyChest();
  const st = gStats();
  const ob = g.obstacle;
  const m = gSectionMeta(g.section);
  const hpPct = Math.max(0, Math.round((ob.hp / ob.maxHp) * 100));
  const coinIco = 'assets/icon_coin.png';
  const upHTML = Object.keys(GAME.up).map((k) => {
    const u = GAME.up[k]; const cost = gUpgradeCost(k); const afford = state.progress.coins >= cost; const lvl = g.up[k];
    return `<button class="adv-up skill-${k} ${afford ? 'buyable' : 'poor'}" data-up="${k}">
      <span class="adv-up-ic">${u.img ? `<img src="${RPG(u.img)}" alt="">` : u.ic}<span class="adv-up-lv">Lv ${lvl}</span></span>
      <span class="adv-up-main"><b>${u.label}</b><span class="adv-up-desc">${u.desc}</span></span>
      <span class="adv-up-cost"><img src="${coinIco}" alt="">${cost}</span>
    </button>`;
  }).join('');
  const gearHTML = gearPanelHTML();

  box.innerHTML = `
    <header class="adv-head">
      <div class="adv-emblem">📖</div>
      <div><h2 class="adv-title">Wissensabenteuer</h2>
        <p class="adv-sub">Bibliothek der Erinnerungen – jede gelernte Karte hilft <b class="adv-hl">Mimorio</b> gegen das Vergessen.</p></div>
    </header>
    <div class="adv-arena ${ob.isExam ? 'exam' : ''}" style="background-image:url(${RPG(m.bg)})">
      <div class="adv-top">
        <span class="adv-chip" title="Wie weit du in der Bibliothek vorgedrungen bist. Jedes besiegte Lernhindernis = +1 Abschnitt.">📖 Abschnitt ${g.section}${ob.isExam ? ' · PRÜFUNG' : ''}</span>
        <span class="adv-chip" title="Lernstufe = die Stärke deines Helden Mimorio. Steigt durchs Lernen und erhöht deine Angriffskraft.">✦ Lernstufe ${g.charLvl}</span>
        <span class="adv-chip"><img src="${coinIco}" alt="">${state.progress.coins}</span>
      </div>
      <div class="adv-xp" title="Erfahrung bis zur nächsten Lernstufe. Neue &amp; fällige Karten geben am meisten.">
        <span class="adv-xp-lbl">Lernstufe ${g.charLvl}</span>
        <div class="adv-xp-bar"><i style="width:${Math.min(100, Math.round((g.charXp / gXpToNext(g.charLvl)) * 100))}%"></i></div>
        <span class="adv-xp-num">${g.charXp} / ${gXpToNext(g.charLvl)} XP</span>
      </div>
      ${advRoomMapHTML()}
      <div class="adv-stage">
        <div class="adv-hero-wrap">
          <div class="adv-speech">Für jedes Wissen werde ich stärker!</div>
          <img class="adv-hero-img" src="${RPG('hero.png')}" alt="Mimorio">
          ${g.activePet && g.pets[g.activePet] ? `<img class="adv-pet" src="${RPG(ADV_PETS[g.activePet].img)}" alt="" title="${esc(ADV_PETS[g.activePet].name)} · ${esc(ADV_PETS[g.activePet].desc)}">` : ''}
        </div>
        <div class="adv-enemy ${ob.isExam ? 'boss' : ''} ${(ob.sprites && ob.sprites.length > 1) ? 'group' : ''} ${ob.elite ? 'elite' : ''}">
          <div class="adv-enemy-name">${esc(ob.name)}${ob.isExam ? ' 📜' : ''}</div>
          ${ob.isExam && (ob.shield || 0) > 0 ? `<div class="adv-shield" title="Boss-Schild: ${ob.shield} Treffer bis er bricht.">🛡️ ${'◆'.repeat(ob.shield)}${'◇'.repeat(Math.max(0, (ob.shieldMax || ob.shield) - ob.shield))}</div>` : ''}
          <div class="adv-hpbar"><i style="width:${hpPct}%"></i></div>
          <div class="adv-hp-text">${Math.max(0, ob.hp)} / ${ob.maxHp} HP</div>
          <div class="adv-enemy-imgs">${(ob.sprites && ob.sprites.length ? ob.sprites : [{ img: m.enemy, boss: ob.isExam }]).map((sp) => `<img class="adv-enemy-img ${sp.boss ? 'is-boss' : 'is-side'}" src="${RPG(sp.img)}" alt="" title="${esc(sp.name || ob.name)}">`).join('')}</div>
        </div>
      </div>
      <div class="adv-statsbar" id="adv-statsbar">
        <span title="Wissensmünzen, die du auch im Leerlauf sammelst."><img src="${coinIco}" alt="">${Math.round(st.coinsPerMin)} Wissensmünzen/min</span>
        <span title="Angriffskraft: wie viel Schaden eine gelernte Karte macht. Steigt mit Lernstufe, reifen Karten, Verbesserungen, Ausrüstung, Sets &amp; Haustier.">📖 Wissen ${Math.round(st.knowledge)}</span>
        <span title="Geistesblitz: Chance auf einen kritischen Treffer (doppelter Schaden).">✨ Geistesblitz ${Math.round(st.crit)} %</span>
      </div>
    </div>
    <div class="adv-actions">
      <button class="adv-fight">⚔ Wissensduell starten</button>
      <button class="adv-chest-btn ${g.chests > 0 ? 'has' : ''}" id="adv-chest">🎁 Schatztruhen · ${g.chests}</button>
    </div>
    <div class="adv-tools">
      <button class="adv-tool" id="adv-map">🗺️ Reisekarte</button>
      <button class="adv-tool" id="adv-compendium">📖 Kompendium</button>
      <button class="adv-tool" id="adv-pets">🐾 Haustiere</button>
      <button class="adv-tool" id="adv-board">🏆 Bestenliste</button>
      <button class="adv-tool" id="adv-duel">⚔️ Freundesduell</button>
    </div>
    ${questCardHTML()}
    <div class="game-panel"><h3 class="game-h">Verbesserungen</h3><div class="adv-upgrades">${upHTML}</div></div>
    <div class="game-panel skilltree-panel"><h3 class="game-h">⚡ Fokus-Spezialangriff <small class="quest-sub">wähle deinen Meter-Angriff</small></h3>${skillTreeHTML()}</div>
    <div class="game-panel"><h3 class="game-h">Lernbegleiter &amp; Ausrüstung</h3><div id="adv-gear">${gearHTML}</div></div>
    <div class="adv-tip"><span class="adv-tip-l">⭐ <b>Tipp:</b> Jede Welt endet mit einer großen Wissensprüfung – und je tiefer du kommst, desto mehr Lernhindernisse warten davor. Bosse geben garantiert eine Truhe.</span><span class="adv-tip-chest">🎁</span></div>`;

  box.querySelectorAll('[data-up]').forEach((b) => { b.onclick = () => gBuyUpgrade(b.dataset.up); });
  box.querySelectorAll('[data-equip]').forEach((b) => { b.onclick = () => gEquip(b.dataset.equip); });
  box.querySelectorAll('[data-ench]').forEach((b) => { b.onclick = (e) => { e.stopPropagation(); gEnchantItem(b.dataset.ench); }; });
  box.querySelectorAll('[data-gearsort]').forEach((b) => { b.onclick = () => { state.gearSort = b.dataset.gearsort; renderGearPanel(); }; });
  box.querySelectorAll('[data-gearfilter]').forEach((b) => { b.onclick = () => { state.gearFilter = b.dataset.gearfilter; renderGearPanel(); }; });
  const qc = box.querySelector('#quest-claim'); if (qc) qc.onclick = gClaimQuest;
  const wc = box.querySelector('#weekly-claim'); if (wc) wc.onclick = gClaimWeekly;
  box.querySelector('.adv-fight').onclick = () => {
    const pool = scopedCards();
    if (pool.length) return startSession(pool, true);
    if (state.cards.length) return startSession(state.cards, true);
    toast('Erst Karten anlegen – dann kann Mimorio kämpfen!');
    cardManagerModal();
  };
  box.querySelector('#adv-chest').onclick = advOpenChest;
  box.querySelectorAll('[data-skill]').forEach((b) => { b.onclick = () => gSkillNodeClick(b.dataset.skill); });
  box.querySelector('#adv-map').onclick = journeyMapModal;
  box.querySelector('#adv-compendium').onclick = kompendiumModal;
  box.querySelector('#adv-pets').onclick = petModal;
  box.querySelector('#adv-board').onclick = advLeaderboardModal;
  box.querySelector('#adv-duel').onclick = advDuelModal;
  if (gotFreeChest) {
    setTimeout(() => pushPop({ img: RPG('chest3.png'), eyebrow: 'Willkommen zurück! 🐱', name: 'Tägliche Gratis-Truhe', reward: '🎁 +1 Schatztruhe – jeden Tag beim ersten Besuch' }), 400);
    try { confetti(); } catch (e) {}
  }
  advStartTick();
}
/* ── Skill-Baum: echter, verzweigter Fähigkeitsbaum ──
   Wuchtschlag (Wurzel) → verzweigt zu Kettenschlag / Goldrausch → mündet in Krit-Rausch. */
export function skillTreeHTML() {
  const g = G(); const cur = gFokusSpecial(); const pts = gSkillPoints();
  const edges = SKILL_TREE.filter((n) => n.req).map((n) => {
    const p = SKILL_BY_ID[n.req]; const [x1, y1] = p.pos, [x2, y2] = n.pos; const on = gSkillUnlocked(n.id);
    return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" class="st-edge ${on ? 'on' : ''}" vector-effect="non-scaling-stroke"/>`;
  }).join('');
  const nodes = SKILL_TREE.map((n) => {
    const unlocked = gSkillUnlocked(n.id); const can = gSkillCanUnlock(n); const activeSp = n.fokus && cur === n.fokus;
    const cls = unlocked ? (n.fokus ? 'unlocked fokus' + (activeSp ? ' active' : '') : 'unlocked done') : (can ? 'avail' : 'locked');
    const [x, y] = n.pos;
    const tag = unlocked ? (n.fokus ? (activeSp ? '✓ Aktiv' : 'Aktivieren') : '✓ frei') : (can ? `${n.cost} ⭐` : `🔒 ${n.cost} ⭐`);
    return `<button class="st-node ${cls}" style="left:${x}%;top:${y}%" data-skill="${n.id}" title="${esc(n.name)} — ${esc(n.desc)}${n.cost ? ' (Kosten: ' + n.cost + ' Skillpunkte)' : ''}">
      <span class="st-node-ring"><span class="st-node-ic">${unlocked || can ? n.icon : '🔒'}</span></span>
      <span class="st-node-name">${esc(n.name)}</span>
      <span class="st-node-tag">${tag}</span>
    </button>`;
  }).join('');
  return `<div class="skilltree-wrap">
    <div class="st-points">⭐ <b>${pts}</b> Skillpunkte frei <small>· 1 pro Lernstufe (Stufe ${g.charLvl})</small></div>
    <div class="skilltree-tree big">
      <svg class="st-edges" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">${edges}</svg>
      ${nodes}
    </div>
    <p class="st-hint">🌱 Sammle Skillpunkte durch Lernstufen und schalte <b>mehrere Äste gleichzeitig</b> frei. Passive Knoten wirken sofort; Fokus-Knoten (💥⛓️🌟🪙) kannst du als aktiven Meter-Angriff wählen.</p>
  </div>`;
}

/* ── Generisches Abenteuer-Overlay ── */
export function advModal(title, inner, cls = '') {
  const ov = document.createElement('div');
  ov.className = 'adv-modal-ov';
  ov.innerHTML = `<div class="adv-modal ${cls}">
    <button class="adv-modal-x" title="Schließen">✕</button>
    <h3 class="adv-modal-h">${title}</h3>
    <div class="adv-modal-body">${inner}</div>
  </div>`;
  document.body.appendChild(ov);
  const close = () => ov.remove();
  ov.querySelector('.adv-modal-x').onclick = close;
  ov.onclick = (e) => { if (e.target === ov) close(); };
  document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
  return ov;
}

/* ── Reisekarte (Journey Map) ── */
export function worldMeta(w) {
  const from = worldStart(w); const len = worldLen(w); const World = gWorld(w);
  return { tier: (w - 1) % 3, bg: World.bg, boss: World.boss.name, name: World.name, from, to: from + len - 1, len, enemies: len - 1 };
}
export function journeyMapModal() {
  const g = G();
  const curWorld = sectionWorld(g.section).world;
  // Alle Welten der Rotation zeigen (mind. eine volle Runde), plus etwas Ausblick.
  const maxWorld = Math.max(ADV_WORLDS.length, curWorld + 1);
  let clearedCount = 0;
  let nodes = '';
  for (let w = 1; w <= maxWorld; w++) {
    const m = worldMeta(w);
    const cleared = g.maxSection > m.to;                 // Welt komplett (Boss besiegt)
    if (cleared) clearedCount++;
    const current = g.section >= m.from && g.section <= m.to;
    const status = cleared ? 'cleared' : current ? 'current' : 'locked';
    const inWorld = current ? (g.section - m.from + 1) : 0;
    const sub = cleared ? '✓ Boss besiegt'
      : current ? `Raum ${inWorld} / ${m.len} · noch ${Math.max(0, m.len - inWorld)} bis zum Boss`
        : `${m.enemies} Gegner + Boss`;
    nodes += `<div class="jm-node ${status}">
      <div class="jm-thumb" style="background-image:url(${RPG(m.bg)})">
        <span class="jm-badge">${cleared ? '👑' : current ? '📍' : '🔒'}</span>
        <span class="jm-foecount">${cleared ? '✓' : '⚔ ' + m.enemies}</span>
        ${current ? `<img class="jm-hero" src="${RPG('hero.png')}" alt="">` : ''}
      </div>
      <div class="jm-info"><b>Welt ${w} · ${esc(m.name)}</b><span class="jm-sub">${sub}</span>
        <span class="jm-boss">${cleared ? '🏆 ' : current ? '⚔️ ' : '💤 '}Boss: ${esc(m.boss)}</span></div>
    </div>`;
    if (w < maxWorld) nodes += `<div class="jm-link ${cleared ? 'done' : ''}"></div>`;
  }
  advModal('🗺️ Reisekarte – Bibliothek der Erinnerungen',
    `<p class="adv-modal-sub">Du hast <b>${clearedCount}</b> Welt${clearedCount === 1 ? '' : 'en'} befreit und stehst in <b>Welt ${curWorld}</b>. Jede Welt hat einen eigenen Ort – und je tiefer du kommst, desto <b>mehr Lernhindernisse</b> stehen bis zum Boss zwischen dir und der nächsten Welt.</p>
     <div class="journey-map">${nodes}</div>`, 'wide');
}

/* ── Haustier-Truhen (Diamant-Sink) + Sammlung ── */
export function gRollPet() {
  const rk = Object.keys(PET_RARITY); const w = rk.map((k) => PET_RARITY[k].w);
  let r = Math.random() * w.reduce((a, b) => a + b, 0); let rar = rk[0];
  for (let i = 0; i < rk.length; i++) { if (r < w[i]) { rar = rk[i]; break; } r -= w[i]; }
  const pool = Object.keys(ADV_PETS).filter((id) => ADV_PETS[id].rarity === rar);
  const id = pool.length ? pool[Math.floor(Math.random() * pool.length)] : Object.keys(ADV_PETS)[0];
  return { id, rarity: ADV_PETS[id].rarity };
}
export function gEquipPet(id) {
  const g = G(); if (!g.pets || !g.pets[id]) return;
  g.activePet = (g.activePet === id) ? null : id;
  try { SFX.good(); } catch (e) {}
  saveProgress();
  const ov = document.querySelector('.adv-modal-ov'); if (ov) ov.remove();
  if (state.view === 'adventure') renderAdventure();
  petModal();
}
export function gOpenPetChest() {
  const g = G();
  if (state.progress.gems < PET_CHEST_COST) { toast(`Du brauchst ${PET_CHEST_COST} 💎 – sammle Diamanten aus Prüfungen, Wochenzielen & Truhen.`); petModal(); return; }
  state.progress.gems -= PET_CHEST_COST;
  const roll = gRollPet(); const pet = ADV_PETS[roll.id]; const rar = PET_RARITY[roll.rarity];
  if (!g.pets) g.pets = {};
  const existing = g.pets[roll.id];
  let refund = 0, leveled = false, maxed = false, newPet = false;
  if (!existing) { g.pets[roll.id] = { level: 1 }; newPet = true; if (!g.activePet) g.activePet = roll.id; }
  else if ((existing.level || 1) < PET_MAX) { existing.level = (existing.level || 1) + 1; leveled = true; }
  else { maxed = true; refund = PET_DUPE_REFUND; state.progress.gems += refund; }
  const lvNow = g.pets[roll.id].level;
  const revealMsg = newPet ? '✨ Neuer Begleiter! ' + pet.desc
    : leveled ? `⬆ Aufgestiegen auf Stufe ${lvNow}! Stärkerer Bonus.`
      : `Bereits Stufe ${PET_MAX} (max) – ${refund} 💎 zurück`;
  saveProgress(); renderCurrency();
  const ov = document.createElement('div'); ov.className = 'chest-ov';
  ov.innerHTML = '<div class="chest-stage"><img class="chest-img" src="' + RPG('chest0.png') + '"></div>';
  document.body.appendChild(ov);
  const img = ov.querySelector('.chest-img'); const frames = ['chest0.png', 'chest1.png', 'chest2.png', 'chest3.png'];
  let i = 0; try { SFX.flip(); } catch (e) {}
  const anim = setInterval(() => {
    i++;
    if (i < frames.length) { img.src = RPG(frames[i]); try { SFX.flip(); } catch (e) {} }
    else {
      clearInterval(anim);
      try { (roll.rarity === 'myth' || roll.rarity === 'legend') ? SFX.win() : SFX.unlock(); } catch (e) {} confetti();
      ov.querySelector('.chest-stage').innerHTML =
        `<div class="pet-reveal ${rar.cls}">
           <div class="pet-reveal-rar">${rar.name}es Haustier${newPet ? '' : ' · Stufe ' + lvNow}</div>
           <div class="pet-frame"><img src="${RPG(pet.img)}" alt=""></div>
           <b class="pet-reveal-name">${esc(pet.name)}</b>
           <div class="pet-reveal-desc">${revealMsg}</div>
         </div>`
        + '<button class="btn-primary chest-close">' + (maxed ? 'Schade ✦' : 'Einsammeln ✦') + '</button>';
      ov.querySelector('.chest-close').onclick = () => { ov.remove(); if (state.view === 'adventure') renderAdventure(); petModal(); };
    }
  }, 300);
}
export function petModal() {
  const g = G();
  const total = Object.keys(ADV_PETS).length;
  const foundN = Object.keys(ADV_PETS).filter((id) => g.pets && g.pets[id]).length;
  const active = (g.activePet && ADV_PETS[g.activePet]) ? ADV_PETS[g.activePet] : null;
  const cells = Object.keys(ADV_PETS).map((id) => {
    const p = ADV_PETS[id]; const have = !!(g.pets && g.pets[id]); const on = g.activePet === id; const rar = PET_RARITY[p.rarity];
    const lv = gPetLevel(id); const stars = have ? '★'.repeat(lv) + '☆'.repeat(PET_MAX - lv) : '';
    return `<button class="pet-cell ${have ? rar.cls : 'locked'} ${on ? 'active' : ''}" ${have ? `data-pet="${id}"` : ''} title="${have ? (on ? 'Aktiv – klick zum Ablegen' : 'Als Begleiter wählen') : 'Noch nicht entdeckt'}">
      <div class="pet-cell-img"><img src="${RPG(p.img)}" alt="">${have ? `<span class="pet-lv">St. ${lv}</span>` : '<span class="kp-q">?</span>'}${on ? '<span class="pet-on">✓</span>' : ''}</div>
      <div class="pet-cell-name">${have ? esc(p.name) : '???'}</div>
      <div class="pet-cell-rar">${have ? rar.name : ''}</div>
      <div class="pet-cell-stars">${stars}</div>
      <div class="pet-cell-desc">${have ? esc(petBonusText(id)) : esc(p.desc)}</div>
    </button>`;
  }).join('');
  advModal('🐾 Haustier-Begleiter',
    `<div class="pet-top">
       <div class="pet-active ${active ? PET_RARITY[ADV_PETS[g.activePet].rarity].cls : ''}">${active ? `<img src="${RPG(active.img)}" alt=""><div><b>Aktiv: ${esc(active.name)} · Stufe ${gPetLevel(g.activePet)}</b><span>${esc(petBonusText(g.activePet))}</span></div>` : '<div class="pet-active-none">Kein Begleiter aktiv – wähle unten einen aus.</div>'}</div>
       <button class="btn-primary pet-open-btn" id="pet-open">🎁 Haustier-Truhe öffnen · ${PET_CHEST_COST} 💎</button>
     </div>
     <p class="adv-modal-sub">Öffne mit Diamanten seltene Truhen und sammle <b>${foundN}/${total}</b> Begleiter. Doppelte <b>leveln</b> das Haustier (bis Stufe ${PET_MAX}) für einen stärkeren Bonus. Dein aktiver Begleiter läuft neben Mimorio.</p>
     <div class="pet-grid">${cells}</div>`, 'wide');
  const ov = document.querySelector('.adv-modal-ov:last-child');
  ov.querySelector('#pet-open').onclick = () => { ov.remove(); gOpenPetChest(); };
  ov.querySelectorAll('[data-pet]').forEach((b) => b.onclick = () => gEquipPet(b.dataset.pet));
}

